import { Outlet } from 'react-router-dom';
import { Container } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import Loader from './Loader';
import Footer from './Footer/index';

export default function SimpleLayout() {
  const scrollContainerRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container
      maxWidth="xl"
      style={{
        backgroundColor: 'white',
        paddingRight: '0px',
        paddingLeft: '0px',
        paddingTop: '0px',
        minHeight: '100vh',
        height: '100vh',
        overflowY: 'auto',
        marginTop: '0px',
      }}
      id="scroll-container"
      ref={scrollContainerRef}
    >
      {loading ? (
        <Loader />
      ) : (
        <div style={{ minHeight: '100vh' }}>
          <Outlet />
        </div>
      )}

      {!loading && <Footer />}
    </Container>
  );
}
